"use client";

interface TourRouteMapLegendProps {
    startLabel: string;
    stopLabel: string;
    endLabel: string;
    className?: string;
}

export default function TourRouteMapLegend({
    startLabel,
    stopLabel,
    endLabel,
    className = '',
}: TourRouteMapLegendProps) {
    return (
        <div
            className={`flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-gray-600 ${className}`.trim()}
            role="list"
            aria-label="Map legend"
        >
            <span className="inline-flex items-center gap-1.5" role="listitem">
                <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-green-600 text-[10px] font-bold text-white" aria-hidden>
                    1
                </span>
                {startLabel}
            </span>
            <span className="inline-flex items-center gap-1.5" role="listitem">
                <span
                    className="inline-flex h-5 w-5 items-center justify-center rounded-full border-2 border-alsero-first bg-white text-[10px] font-bold text-alsero-first"
                    aria-hidden
                >
                    2
                </span>
                {stopLabel}
            </span>
            <span className="inline-flex items-center gap-1.5" role="listitem">
                <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-slate-800 text-[10px] font-bold text-white" aria-hidden>
                    n
                </span>
                {endLabel}
            </span>
        </div>
    );
}
